export enum CampaignStatus {
    Active = 'active',
    Finished = 'finished'
};

export enum CampaignType {
    Fruit = 'fruit',
    Plant = 'plant'
};
